// ----------------------------------------------------------------------

import { TypographyOwnProps } from "@mui/material";

declare module '@mui/material/Link' {
  interface LinkPropsVariantOverrides {
    body1_14: true;
  }
}

interface ExxtendLinkOwnProps extends TypographyOwnProps {
  body1_14: React.CSSProperties;
  secondary: React.CSSProperties;
  tertiary: React.CSSProperties;
}

const link = {
  body1_14: {},
  secondary: {},
  tertiary: {},
} as ExxtendLinkOwnProps;

export default link;
